module.exports = __webpack_public_path__ + "static/media/Illustration.a7e60ade.png";